import { UpdatingIndicatorIcon } from "~/ui-library/icons";
import { SVGProps } from "react";

export const LoadingSpinner: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <UpdatingIndicatorIcon
    aria-label="Loading"
    className="animate-spin self-center stroke-black"
    width={props.width ?? 32}
    height={props.height ?? 32}
  />
);
